












































































































import { Component, Vue } from 'vue-property-decorator';
import AppMessage from '../../core/models/appMessage';
import { IntegrationVm } from '../classes/integrationVm';
import { IntegrationApi } from '../api/integrations';
import { ElTable } from 'element-ui/types/table';
import { IntegrationDefinitionVm, RemoveBehaviour } from '../classes/integrationDefinitionVm';
import appMessage from '../../core/models/appMessage';

@Component
export default class List extends Vue {
  public tableColumns: any[] = [];
  public integrationsData: IntegrationVm[] = [];
  public loading: boolean = false;
  public editModeFields: any = {};
  public editGroupIds: any = {};
  public integrations: IntegrationDefinitionVm[] = [];
  private api: IntegrationApi;
  constructor() {
    super();
    this.api = new IntegrationApi();
  }

  public async created() {
    this.tableColumns = [
      {
        prop: 'type',
        label: this.$t('integrations.type'),
        sortable: true,
      },
      {
        prop: 'id',
        label: this.$t('integrations.domain'),
        sortable: true,
      }
    ];

    this.refresh();

    const integrations = await this.api.getIntegrationsDefinitions();
    this.integrations = integrations;
  }

  public async refresh() {
    this.loading = true;
    try {
      this.integrationsData = await this.api.list();
    } catch (error) {
      AppMessage.show(this.$t('integrations.dataLoadError'), 'error');
    }
    this.loading = false;
  }

  public toIntegration(id: string) {
    this.$router.push('/integration?id=' + id);
  }

  public async deleteIntegration(integration: IntegrationVm)
  {
    this.$confirm(
      this.$t('devices.deleteText') as string,
      `${this.$t('integrations.deleteTitle') as string} ${integration.type}`,
      {
        confirmButtonText: this.$t('general.yes') as string,
        cancelButtonText: this.$t('general.no') as string,
        type: 'warning',
        customClass: 'deviceRemoveDialog',
      },
    ).then(async () => {
   var deletetionResult = await this.api.deleteIntegration(integration);
    if(deletetionResult)
    {
      appMessage.show(this.$t('integrations.deleteSuccess'), "success")
    }else{
      appMessage.show(this.$t('integrations.deleteError'), "error")
    }
    this.refresh();
    })
  }
  public async activateIntegration(integration: IntegrationVm)
  {
    var deletetionResult = await this.api.activateIntegration(integration);
    if(deletetionResult)
    {
      appMessage.show(this.$t('integration.activateSuccess'), "success")
    }else{
      appMessage.show(this.$t('integration.activateError'), "error")
    }
    this.refresh();
  }
  public isExternalRemove(integration: IntegrationVm) : boolean
  {
    return this.integrations.some(n => n.name.toLowerCase() == integration.type 
      && n.removeBehaviour == RemoveBehaviour.External);
  }
  public isTurnOff(integration: IntegrationVm) : boolean
  {
    return integration.status === 'turnoff';
  }
  public async updateIntegration(integration: IntegrationVm)
  {
    var updateResult = await this.api.setIntegration(integration);
    if(updateResult)
      {
        appMessage.show(this.$t('integration.updateSuccess'), "success")
      }else{
        appMessage.show(this.$t('integration.deleteError'), "error")
      }
  }
}
